// 中文语言包 - 基于 zn 文件夹内容
export default {
  common: {
    home: '首页',
    products: '产品中心',
    application: '应用领域',
    quality: '质量管理',
    about: '关于我们',
    contact: '联系我们',
    search: '搜索',
    searchPlaceholder: '请输入关键词',
    login: '登录',
    logout: '退出登录',
    more: '查看更多',
    viewFile: '查看文件',
    downloadFile: '下载文件',
    onlineHelp: '选型手册下载',
    en: 'EN',
    english: 'English',
    simplifiedChinese: '中文（简体）',
    traditionalChinese: '中文（繁体）',
    noData: '暂无数据',
    loading: '加载中...',
    noFiles: '暂无文件'
  },
  nav: {
    home: '首页',
    products: '产品中心',
    application: '应用领域',
    applicationIndustry: '行业应用',
    applicationManual: '产品应用手册',
    quality: '质量管理',
    newsCenter: '新闻中心',
    companyNews: '公司动态',
    techCategory: '技术分类',
    about: '关于我们',
    investor: '投资者关系',
    contact: '联系我们',
    memsSensor: 'MEMS传感器',
    memsSiliconMicrophone: 'MEMS硅麦克风传感器芯片'
  },
  home: {
    powerProducts: '功率产品',
    audioProducts: '音频产品',
    audioSignalChainChips: '音频信号链芯片',
    aboutUs: '关于我们',
    coreProducts: '核心产品',
    coreProductsDesc: '业界领先产品',
    seniorIntroduction: '高层介绍',
    seniorIntroductionDesc: '高层介绍',
    newsInformation: '新闻资讯',
    newsInformationDesc: '新闻资讯',
    technicalSharing: '技术分享',
    technicalSharingDesc: '技术分享',
    greenEnergy: '绿色能源',
    communication: '通信',
    smartLife: '智能生活',
    automotive: '汽车',
    computing: '计算',
    industry: '工业',
    sicMosfet: '碳化硅MOSFET',
    automotivePower: '汽车功率半导体',
    memsMicrophone: 'MEMS硅麦克风传感器芯片',
    sicMosfetDesc1: '产品性能指标达到全球第一梯队',
    sicMosfetDesc2: '8英寸SiC MOS',
    sicMosfetDesc3: '汽车、充电桩、光伏储能、服务器电源、工业领域大批量出货',
    sicMosfetDesc4: '芯联集成供应链战略支持',
    automotivePowerDesc1: '国内产品布局最全面的功率半导体平台型企业',
    automotivePowerDesc2: 'SiC MOS、IGBT、硅基MOS、FRD等均在车载客户中实现大批量出货',
    automotivePowerDesc3: '覆盖汽车电驱、电池、底盘、热管理、车身、座舱等全应用领域',
    automotivePowerDesc4: '多家全球顶级车载客户核心国产功率半导体供应商',
    memsMicrophoneDesc1: '累计出货数量超过20亿颗，位居全球前列',
    memsMicrophoneDesc2: '智能终端头部品牌全覆盖'
  },
  about: {
    title: 'ALKAIDSEMI',
    slogan: '共创智能与可持续的未来',
    corporateCulture: '企业文化',
    corporateCultureTitle: 'Corporate<br>Culture',
    corporateCultureDesc: '企业文化',
    esg: 'ESG',
    companyIntro: '企业简介',
    corporateVideo: '企业视频',
    videoNotSupported: '您的浏览器不支持Video标签。',
    vision: {
      title: '愿景',
      content: '成为国际一流的<br>模拟器件和数模混合<br>芯片公司'
    },
    mission: {
      title: '使命',
      content: '专注信息与能源<br>让生活更美好、更高效'
    },
    values: {
      title: '价值观',
      content: '客户:以客户为中心<br>创新:持续创新<br>卓越:追求卓越<br>奋进:以奋斗者为基<br>以进击者为荣'
    }
  },
  products: {
    title: '产品中心'
  },
  footer: {
    productCenter: '产品中心',
    productApplication: '产品应用',
    qualityManagement: '质量管理',
    aboutYaoxin: '关于瑶芯',
    contactUs: '联系我们',
    slogan: '共创智能与可持续的未来',
    siliconPower: '硅功率器件',
    sicPower: '碳化硅功率器件',
    memsSensor: 'MEMS传感器',
    signalChain: '信号链芯片',
    automotive: '汽车',
    greenEnergy: '绿色能源',
    communication: '通信',
    highPerformanceComputing: '高性能计算',
    industry: '工业',
    smartLife: '智能生活',
    qualityPolicy: '质量方针',
    qualityCert: '质量体系认证证书',
    totalQuality: '全面质量管理',
    contactMethod: '联系方式',
    salesNetwork: '销售网络',
    feedback: '留言反馈',
    privacyPolicy: '隐私政策',
    copyright: '版权所有 © 2024 瑶芯微（上海）电子科技股份有限公司'
  },
  contact: {
    title: '联系我们',
    subtitle: '欢迎与我们取得联系',
    returnHome: '返回首页',
    leaveMessage: '给我们留言',
    leaveMessageDesc: '如有问题与建议，请填写下方表格联系我们。我们会在24小时内答复您。',
    form: {
      name: '您的姓名*',
      phone: '您的手机号*',
      company: '您的公司名称',
      email: '您的邮箱',
      message: '留言*',
      submit: '立即提交',
      readAgreement: '我已阅读',
      userAgreement: '用户使用协议',
      privacyPolicy: '隐私政策'
    },
    validation: {
      enterName: '请填写联系人姓名',
      enterPhone: '请填写联系电话',
      invalidPhone: '不是手机号码',
      enterCompany: '请填写公司名称',
      enterMessage: '请填写留言内容',
      checkAgreement: '请勾选我已阅读用户使用协议',
      confirmSubmit: '确认提交留言',
      submitSuccess: '留言成功,我们会尽快联系您!',
      submitFailed: '提交失败，请稍后重试。'
    },
    labels: {
      contact: '联系人：',
      phone: '电话：',
      email: '邮箱：',
      address: '地址：'
    },
    cities: {
      shanghai: {
        name: '上海'
      },
      shenzhen: {
        name: '深圳'
      },
      xian: {
        name: '西安'
      },
      chengdu: {
        name: '成都'
      }
    }
  },
  investor: {
    download: '下载',
    noData: '暂无数据',
    view: '查看',
    viewDetail: '查看详情',
    viewFile: '查看文件',
    disclosure: '信息披露',
    governanceTitle: '企业管治',
    stockInfo: '股票信息',
    investorLog: '投资者日志',
    investorContact: '投资者关系联络',
    title: '投资者关系',
    subtitle: 'Investor Relations',
    breadcrumbHome: '首页',
    breadcrumbInvestor: '投资者关系',
    query: '查询',
    meetingRegistration: '点击进入会议注册及网络广播',
    pageTitles: {
      disclosure: '信息披露',
      governance: '企业管治',
      stockInfo: '股票信息',
      investorLog: '投资者日志',
      investorContact: '投资者关系联络'
    },
    subNav: {
      prospectus: '招股文件',
      reports: '业绩报告',
      announcements: '公告及通函',
      presentations: '推介会材料',
      emails: '电邮通知'
    },
    columns: {
      hShares: 'H股',
      otherDocuments: '其他文档'
    },
    icons: {
      expand: '展开',
      collapse: '收起',
      search: '搜索',
      date: '日期',
      report: '报告'
    },
    search: {
      placeholder: '请输入关键词搜索'
    },
    contact: {
      title: '投资者关系联络',
      department: '投资者关系部门',
      workingHours: '工作时间',
      onlineConsultation: '在线咨询',
      form: {
        name: '姓名',
        email: '邮箱',
        phone: '电话',
        message: '咨询内容',
        submit: '提交'
      },
      address: '地址',
      email: '电子邮件',
    },
    governance: {
      companyStructure: '公司架构',
      boardCommittees: '董事会委员会',
      directorsSupervisors: '董事、监事及高级管理人员',
      companyStructureTitle: '公司架构',
      companyStructureDesc: '公司组织架构图',
      executiveDirectors: '执行董事',
      nonExecutiveDirectors: '非执行董事',
      independentDirectors: '独立非执行董事',
      auditCommittee: '审计委员会',
      remunerationCommittee: '薪酬委员会',
      nominationCommittee: '提名委员会',
      corporateGovernanceCommittee: '企业管治委员会',
      chairman: '主席',
      governanceDocuments: '治理文件'
    }
  },
  product: {
    downloadMerged: '下载合并文档',
    downloadFailed: '下载失败',
    selectAtLeastOneDoc: '请至少选择一个文档',
    noDataToExport: '暂无数据可导出',
    exportFailed: '导出失败',
    returnToList: '返回列表',
    returnToDirectory: '返回目录',
    signalChainChips: '信号链芯片',
    audioSignalChainChips: '音频信号链芯片',
    productCenter: '产品中心',
    title: '标题',
    type: '类型',
    date: '日期',
    document: '文档',
    selectAll: '全选',
    productParams: '产品参数',
    technicalDocs: '技术文档',
    clickPartNumber: '点击料号名称可查看详细资料',
    noCategoryInfo: '暂无该类别的信息',
    select: '选择',
    reset: '重置',
    exportTable: '导出选型表格',
    learnMore: '进一步了解',
    selectAtLeastOne: '请至少选择一个产品',
    selectAtLeastOneDoc: '请至少选择一个文档',
    productsDescription: '瑶芯致力于功率器件、智能传感器和信号链芯片的设计、研发和销售，主营产品为全品类功率器件（SiC MOS、IGBT、SJ MOS以及中低压MOS）、MEMS传感器以及信号链芯片。',
    loading: '加载中...',
    audioSignalChainTitle: '音频信号链芯片',
    audioSignalChainDescription: '瑶芯以MEMS麦克风为抓手，构建了从信号采集（MEMS Sensor），信号转化（声信号转电信号），信号处理(放大/滤波等)，音频算法（上行/下行），模数转换（ADC），数模转换(DAC)，功放(PA)等音频信号链全过程的开发能力，提供高性能的音频信号链全链条解决方案。'
  },
  application: {
    application: '应用',
    diagram: '框图',
    relatedProducts: '相关产品',
    noApplicationContent: '暂无应用内容',
    noDiagramContent: '暂无框图内容',
    noRelatedProducts: '暂无相关产品',
    productApplication: '产品应用'
  },
  news: {
    returnToList: '返回列表',
    returnHome: '返回首页'
  },
  quality: {
    policy: {
        titleEn: 'Quality Policy',
        titleZh: '质量方针',
        subtitle: '瑶芯始终坚持以创新的设计和高质量的产品为根基，推行全面质量管理，恪守承诺，追求卓越。',
        content: '<p>该方针是我公司经营方针的重要组成部分，与组织的宗旨和环境相适应并支持其战略性方向；提供设定质量目标的框架；包括满足相关要求的承诺；包括持续改进质量管理体系的承诺。各级领导要将质量方针传达到管理、执行、验证和作业等层次人员，使全体员工正确理解并坚决执行。</p>'
    },
    system: {
        titleEn: 'Quality System',
        titleZh: '质量体系认证证书',
        content: '<p>瑶芯始终追求质量管理体系的最高标准。瑶芯微作为知名设计公司的地位坚定不移，并获得了 ISO9001（质量体系管理）和 ISO26262（功能安全管理）的质量认证。</p>',
        partnerTitle1: '我们的协作战略制造合作伙伴',
        partnerTitle2: '还满足以下管理体系标准：'
    },
    certificates: {
        iso9001: '质量体系管理',
        iatf16949: '汽车质量体系管理',
        iso14001: '环境管理体系',
        qc080000: '有害物质过程管理',
        iso45001: '职业安全与健康管理'
    },
    tqm: {
        titleEn: 'TQM',
        titleZh: '全面质量管理',
        content: '<p>正如我们的质量政策所涵义的那样，Alkaidsemi 采用全面质量管理（TQM）方法，通过客户满意度取得长期成功。我们组织的所有成员都参与改进我们工作的流程、产品、服务和文化。</p>'
    }
  },
  search: {
    title: '搜索',
    searchTitle: '搜索',
    breadcrumbProducts: '产品中心',
    select: '选择',
    download: '下载',
    noResults: '未找到相关产品',
    loading: '加载中...',
    totalResults: '共找到 {total} 条结果',
    pageSize: '每页条数',
    prevPage: '上一页',
    nextPage: '下一页',
    jumpTo: '跳转到',
    confirm: '确认',
    headers: {
      subject: 'AKS Part Number',
      status: 'Status',
      spiceModel: 'Spice Model',
      package: 'Package',
      cfg: 'Cfg',
      vds: 'VDS(V)',
      vgs: 'Vgs(V)',
      ida: 'ID(A)',
      vth: 'Vth(V)',
      typ10: 'Typ@10V',
      max10v: 'Max@10V',
      typ45: 'Typ@4.5V',
      max45: 'Max@4.5V',
      ciss: 'CISS_Typ(pF)',
      coss: 'COSS_Typ(pF)',
      crss: 'CRSS_Typ(pF)',
      qgnc: 'QG_Typ(nC)',
      pic2: '数据手册',
      spice_model: 'Spice Model'
    }
  },
  login: {
    title: '瑶芯微电子人员登录',
    emailOrUsername: '邮箱/用户名',
    passwordPlaceholder: '请输入密码',
    captchaPlaceholder: '请输入验证码',
    loginButton: '登录',
    enterUsername: '请输入用户名',
    enterPassword: '请输入密码',
    enterCaptcha: '请输入验证码',
    loginFailed: '登录失败，请稍后重试',
    loginError: '用户名或密码错误！',
    apiNotConfigured: '登录功能需要后端API支持，请联系开发人员配置登录接口'
  },
  senior: {
    guo: {
      name: '郭亮良',
      position: '董事长/总经理',
      desc: [
        '• 国家科技创业领军人才',
        '• 曾任中芯国际技术开发资深经理、华虹NEC高压器件和BCD研发主管',
        '• 18年半导体技术开发经验，师从中国第三代半导体领军专家郝跃院士'
      ]
    },
    chen: {
      name: '陈开宇',
      position: '功率产品线负责人',
      desc: [
        '• 21年行业经验，曾担任Diodes全球 MOSFET事业部总经理，丰富的车载及高端功率器件开发经验'
      ]
    },
    wang: {
      name: '王一鸣',
      position: 'IC产品线负责人',
      desc: [
        '• 18年电源领域模拟芯片开发和产品经验，曾任职 MPS工程产品部主管'
      ]
    },
    wangqs: {
      name: '王青松',
      position: '音频产品线负责人',
      desc: [
        '• 18年音频信号链IC开发和产品经验',
        '• 曾任全志科技芯片研发中心技术总监、华为海思麒麟芯片音频信号链研发负责人'
      ]
    },
    li: {
      name: '李卫刚',
      position: '运营负责人',
      desc: [
        '• 20年行业经验，曾担任华虹宏力功率器件工程主管，中芯国际传感器研发主管，熟悉传感器市场和功率器件市场，熟悉FAB和OSAT运营管理'
      ]
    },
    zheng: {
      name: '郑召星',
      position: '质量负责人',
      desc: [
        '• 22年行业经验，曾担任中芯国际工艺整合总监，华力微工艺整合部部长，服务过顶尖客户群，精通FAB工程和量产管理'
      ]
    },
    luo: {
      name: '罗希',
      position: '华东/车载销售',
      desc: [
        '• 23年行业经验，曾担任英飞凌车载事业部资深销售总监，负责ATV所有产品的销售和代理商管理，精通车载市场和整车厂'
      ]
    },
    huang: {
      name: '黄冬榆',
      position: '华南销售',
      desc: [
        '• 23年行业经验，曾担任IR大中华区销售主管，英飞凌PSS事业部销售主管，熟悉电力电子驱动和功率器件市场'
      ]
    },
    zhu: {
      name: '朱魏清',
      position: '音频销售',
      desc: [
        '• 25年半导体从业经验，曾担任CECport市场副总裁，Arrow中国区市场总监，熟悉半导体市场和客户群'
      ]
    }
  }
}

